import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { EmptyTemplateConstants, ExtendedMapTemplate } from '@zep/types';
import { cn } from '@zep/utils';
import { newAiMapSessionPath } from '../ai-map/constants';
import { useAiMapEligibility } from '../ai-map/hooks/useAiMapEligibility';
import { CreateSpaceContent, CreateSpaceHeader, CreateSpacePanel } from './components';
export const CreateSpacePage = () => {
  const router = useRouter();
  const [showPurchasedMaps, setShowPurchasedMaps] = useState(false);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [selectedTemplateWithMetadata, setSelectedTemplateWithMetadata] = useState<ExtendedMapTemplate | null>(null);
  const handleTemplateSelect = (template: ExtendedMapTemplate) => {
    // 이미 선택된 템플릿을 다시 클릭한 경우
    if (selectedTemplateWithMetadata?.hashId === template.hashId && isPanelOpen) {
      setIsPanelOpen(false);
      setSelectedTemplateWithMetadata(null);
    } else {
      // 새로운 템플릿을 선택한 경우
      setSelectedTemplateWithMetadata(template);
      setIsPanelOpen(true);
    }
  };
  const {
    t
  } = useTranslation(['common']);
  // AI generation is a school map contest perk: the button exists only for
  // accounts on the participant list (the server's Authorize gate is the
  // authority; this just keeps the entry point out of everyone else's view).
  const {
    isEligible: canGenerateWithAi
  } = useAiMapEligibility();
  const handleEmptyTemplate = () => {
    const emptyTemplate: ExtendedMapTemplate = {
      hashId: EmptyTemplateConstants.hashId,
      name: t('common:createSpace.emptyTemplate'),
      thumbnailUrl: EmptyTemplateConstants.thumbnailUrl,
      isPurchased: false,
      isEmpty: true
    };
    handleTemplateSelect(emptyTemplate);
  };
  const handleClosePanel = () => {
    setIsPanelOpen(false);
    setSelectedTemplateWithMetadata(null);
  };
  return <div className="flex h-screen bg-gray-50 pt-[64px]" data-sentry-component="CreateSpacePage" data-sentry-source-file="CreateSpacePage.tsx">
      <div className="flex flex-1 flex-col overflow-hidden transition-all duration-300">
        <div className={cn('mx-auto flex h-full w-full flex-col transition-all duration-300 min-w-[738px]', isPanelOpen ? 'max-w-[738px]' : 'max-w-[1140px]')}>
          <CreateSpaceHeader showPurchasedMaps={showPurchasedMaps} onToggleChange={setShowPurchasedMaps} onClickNoTemplate={handleEmptyTemplate} onClickAiGenerate={canGenerateWithAi ? () => void router.push(newAiMapSessionPath()) : undefined} data-sentry-element="CreateSpaceHeader" data-sentry-source-file="CreateSpacePage.tsx" />

          <div className="min-h-0 flex-1">
            <CreateSpaceContent showPurchasedMaps={showPurchasedMaps} onSelectTemplate={handleTemplateSelect} selectedTemplate={selectedTemplateWithMetadata} data-sentry-element="CreateSpaceContent" data-sentry-source-file="CreateSpacePage.tsx" />
          </div>
        </div>
      </div>

      <div className={cn('transition-all duration-300', isPanelOpen ? 'w-[404px]' : 'w-0')} />

      <CreateSpacePanel isOpen={isPanelOpen} onClose={handleClosePanel} selectedTemplate={selectedTemplateWithMetadata} data-sentry-element="CreateSpacePanel" data-sentry-source-file="CreateSpacePage.tsx" />
    </div>;
};